module.exports = __webpack_public_path__ + "img/class-bg.df32a15b.png";